module.exports = __webpack_public_path__ + "img/role-sm.403f5826.png";